module.exports = __webpack_public_path__ + "images/icons/psp/10x30.svg";